module.exports = __webpack_public_path__ + "img/beauseant.ca5f09cb.jpeg";